import { SocialProvider } from '../types/social';

/**
 * ENABLED_PROVIDERS — redes sociales habilitadas en la app (login + publish + header).
 *
 * Es una CONSTANTE: editá esta lista para cambiar qué redes aparecen.
 *   - TikTok-only (demo app-review de social.doer.ar):  ['tiktok']
 *   - Multi-red:                                         ['tiktok', 'instagram', 'google']
 *
 * `fake` (FakeSocialMedia) es un provider de dev: se puede agregar acá para
 * mostrarlo en el login, o dejarlo a cargo de FEATURE_FLAGS.ENABLE_FAKE_SOCIAL.
 */
export const ENABLED_PROVIDERS: SocialProvider[] = ['tiktok'];

export const isProviderEnabled = (p: SocialProvider): boolean =>
  ENABLED_PROVIDERS.includes(p);

/**
 * ONLY_TIKTOK_DEMO — derivado. `true` SÓLO si la única red habilitada es TikTok.
 *
 * Cuando es `true`, la app entra en modo demo TikTok:
 *  - Login: solo aparece el botón de TikTok.
 *  - Share modal: sin chips de selección de cuentas, publicación directa.
 *  - Header: se oculta "Mis redes" del menú de perfil.
 *
 * Se mantiene como export para no romper los gates existentes que lo consumen.
 */
export const ONLY_TIKTOK_DEMO =
  ENABLED_PROVIDERS.length === 1 && ENABLED_PROVIDERS[0] === 'tiktok';

/**
 * HIDE_CATALOG — oculta el catálogo de videos de marcas en "Sumá puntos".
 *
 * Es una CONSTANTE solo-front (igual que ONLY_TIKTOK_DEMO): editá este valor
 * para alternar el comportamiento. No depende del backend.
 *
 * En la home ("Sumá puntos") hoy conviven dos caminos:
 *   - el catálogo de videos de marcas (grilla), y
 *   - el botón "Sumar mis posts" (abre un modal con el flujo de registrar
 *     un post propio que ya publicaste).
 *
 * Cuando es `true`:  se OCULTA el catálogo y el botón. En su lugar la home
 *   embebe directamente el contenido del flujo "Sumar mis posts" inline,
 *   como si el usuario ya hubiera tocado el botón. (No se monta el carrusel.)
 * Cuando es `false`: la home queda EXACTAMENTE como está hoy (catálogo +
 *   botón que abre el modal).
 *
 * Tipado como `boolean` (no el literal `true`) para que alternar el valor no
 * dispare "unreachable/unused code" en el type-check de la rama no usada.
 */
export const HIDE_CATALOG: boolean = false;

/**
 * HIDE_DOWNLOAD_ORIGINAL — oculta el botón "Descargar video original" del
 * share modal (el que baja el MP4 sin optimizar del clip).
 *
 * Es una CONSTANTE solo-front (igual que HIDE_CATALOG / ONLY_TIKTOK_DEMO):
 * editá este valor para alternar el comportamiento. No depende del backend.
 *
 * Cuando es `true`:  el botón NO se renderiza (el endpoint de descarga sigue
 *   existiendo en el backend, sólo se oculta el acceso desde la UI).
 * Cuando es `false`: el botón se muestra como antes.
 *
 * Tipado como `boolean` (no el literal `true`) para no disparar
 * "unreachable/unused code" en el type-check de la rama no usada.
 */
export const HIDE_DOWNLOAD_ORIGINAL: boolean = true;
